import { gql } from "@grandvisionhq/graphql";
const placePredictions = gql`
  fragment PlacePrediction on PlacePrediction {
    id
    locality
    sublocality
  }
`;
const GET_PLACE_PREDICTIONS = gql`
  query GetPlacePredictions($name: String!) {
    placePredictions(name: $name) {
      ...PlacePrediction
    }
  }
  ${placePredictions}
`;
export {
  GET_PLACE_PREDICTIONS
};
//# sourceMappingURL=get-place-predictions.js.map
